module.exports = __webpack_public_path__ + "img/graphic_designer_2_splash.656baafc.jpg";